import { render, staticRenderFns } from "./SeniorMembersList.vue?vue&type=template&id=0dfc9aea"
import script from "./SeniorMembersList.vue?vue&type=script&lang=js"
export * from "./SeniorMembersList.vue?vue&type=script&lang=js"
import style0 from "./SeniorMembersList.vue?vue&type=style&index=0&id=0dfc9aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports